import { assign, setup } from 'xstate'

/** 外部の状態：キャンペーンAPI */
type CAMPAIGN_STAMP_TYPE = 1
type CAMPAIGN_POINT_TYPE = 2 | 3
// あえて、APIのレスポンスとは別に切り出して定義している。
// APIの状態は、それとして受け取りTS内部ではわかりやすい形で保持するため
interface CampaignState {
  campaignStartAt: string
  campaignEndAt: string
  period: boolean
  type: CAMPAIGN_STAMP_TYPE | CAMPAIGN_POINT_TYPE
  isRepeatStamp: boolean
}

/** 内部の状態 */
type HomeStateContext = {
  // APIの状態
  campaign: CampaignState | null
  // APIの読み込みなどの状態
  loadCompleted: boolean
}

// マウント時に実行される状態遷移
// APIの実行や、StateMachine内に状態を保持するようにする
type InitialLoadCampaignEvent = { type: 'onInitialCampaignLoad'; campaign: CampaignState }
type InitialLoadCompleteEvent = { type: 'onInitialCompleteLoad' }
type CheckCampaignIsOpenEvent = { type: 'onCheckCampaignIsOpen' }
type NextEvent = { type: 'onNextEvent' }
type BackEvent = { type: 'onBackEvent' }

type HomeStateEvent =
  | InitialLoadCampaignEvent
  | InitialLoadCompleteEvent
  | CheckCampaignIsOpenEvent
  | NextEvent
  | BackEvent

export const homeStateMachine = setup({
  types: {
    context: {} as HomeStateContext,
    events: {} as HomeStateEvent,
  },
}).createMachine({
  id: 'homeStateMachine',
  initial: 'initial',
  context: {
    campaign: null,
    loadCompleted: false,
  },
  states: {
    // mount時の状態
    initial: {
      type: 'atomic',
      on: {
        onInitialCampaignLoad: {
          target: 'initial',
          actions: [
            assign({
              campaign: ({ event }) => event.campaign,
            }),
          ],
        },
        onInitialCompleteLoad: [
          {
            target: 'initialLoadCompleted',
            guard: ({ context }) => !!context.campaign,
            actions: [
              assign({
                loadCompleted: true,
              }),
            ],
          },
          {
            target: 'initial',
          },
        ],
      },
    },
    initialLoadCompleted: {
      type: 'atomic',
      description: 'mount後のAPIなどが実行された状態',
      on: {
        onCheckCampaignIsOpen: [
          {
            target: 'campaignOutOfPeriod',
            guard: ({ context }) =>
              new Date(context.campaign.campaignEndAt) < new Date() ||
              new Date() < new Date(context.campaign.campaignStartAt),
            //guard: ({ context }) => new Date(context.campaign.campaignEndAt) < new Date(),
          },
          {
            target: 'campaignIsInOpen',
          },
        ],
      },
    },
    campaignIsInOpen: {
      type: 'atomic',
      description: 'キャンペーンが開催されている場合',
    },
    campaignOutOfPeriod: {
      type: 'atomic',
      description: 'キャンペーン開催期間外の場合のステート',
    },
    // 一旦以下の状態は使わないが、列挙
    //popupCheck: {
    //  type: 'atomic',
    //  description: '',
    //},
    //popupShown: {
    //  type: 'atomic',
    //  description: '',
    //},
  },
})
